<template>
<div class="start page one" id="start">
  <h2>Contact Jancarus</h2>
  <h3 style="font-size:1.2rem;"> Choose one category that best suits you.</h3>
  <div class="start-margin">
  <my-booking>
  </my-booking>
</div>
</div>
</template>

<script>
var Booking ={template: '<a id="TTE-3ff4d8ac-8ac3-4fa4-a0ee-77902868a634" href="https://10to8.com/book/bgzqlz-free/" target="_blank">See Online Booking Page</a>',
}

export default{
  components: {
      'my-booking': Booking
  },
  mounted (){
    window.TTE.init({
    targetDivId: 'TTE-3ff4d8ac-8ac3-4fa4-a0ee-77902868a634',
    uuid: '3ff4d8ac-8ac3-4fa4-a0ee-77902868a634' })
  }
}

</script>
<style>
.start-margin{
  width:80vw;
  margin-left:auto;
  display:block;
  margin-right:auto;

}
</style>



// WEBPACK FOOTER //
// src/components/GetStarted.vue